<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="387px"
    :close-on-click-modal="false"
    append-to-body
    class="settlement-select-dialog"
  >
    <div v-if="isBill" style="text-align: left;padding-bottom: 7px;">
      <el-radio-group v-model="createBillWay" @change="createBillWayChange">
        <el-radio :label="0">{{ $t('CargoMsg.Cargo_SettleAccountsTo') }}</el-radio>
        <el-radio :label="1">{{ $t('CargoMsg.Cargo_SettlementAgent') }}</el-radio>
      </el-radio-group>
    </div>
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" :disabled="!btnOkEnable" @click="selectOk()">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'SettlementSelectDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: false },
    accounts: { type: Array, required: true }, // 结算对象
    source: { type: String, required: false }, // 来源[国内账单：internalBillInfo，费用：tabCharges，国外账单：overseaBilling]
    settlements: { type: Array, required: false, default: () => [] } // 结算代理
  },
  data() {
    return {
      innerVisible: false,
      btnOkEnable: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.selectOk,
        onRowClicked: () => { this.btnOkEnable = true }
      },
      columnDefs: [
        {
          headerName: '',
          field: 'chineseName',
          suppressMenu: true,
          minWidth: 360
        }
      ],
      rowData: [],
      gridApi: null,
      createBillWay: 0 // 结算方式【0：结算对象 1、结算代理】
    }
  },
  computed: {
    isBill() { // 判断是否是国内国外
      return ['internalBillInfo', 'overseaBilling'].includes(this.source)
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        this.createBillWay = 0
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    init() {
      this.rowData = !this.createBillWay ? this.accounts : this.settlements
    },
    selectOk(event = null) {
      let currentRow = null
      if (event != null) {
        currentRow = event.data
      } else {
        const cell = this.gridApi.getFocusedCell()
        if (cell) {
          currentRow = !this.createBillWay ? this.accounts[cell.rowIndex] : this.settlements[cell.rowIndex]
        }
        if (!currentRow) {
          this.$message.warning(this.$t('Message.NoDataSelected'))
          return
        }
      }
      this.$emit('selectItemWinHandler', currentRow.cmpIdx, this.createBillWay)
      this.innerVisible = false
    },
    // 结算方式调整
    createBillWayChange() {
      this.gridApi.clearFocusedCell()
      this.init()
    }
  }
}
</script>

<style lang="scss">
.settlement-select-dialog {
  .ag-header {
    display: none;
  }
}
</style>
